/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-21 10:05:00
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-06 16:06:29
 */

const context = import.meta.glob('../../../modules/**/**/zh_CN.js', { eager: true })
let modulesLabels = {}
Object.keys(context).forEach((key) => {
  const [path, module, base, fileName] = key.replace(/(\..\/|\/module\/|\.js)/g, '').split('/')
  const tempObj = {}
  tempObj[module] = context[key].default
  modulesLabels = { ...modulesLabels, ...tempObj }
})
const lang = {
  ...modulesLabels,
  common: {
    serialNumber: '序号',
    edit: '编辑',
    delete: '删除',
    view: '详情',
    detail: '详情',
    add: '新增',
    sure: '确定',
    save: '保存',
    confirm: '确认',
    cancel: '取消',
    close: '关闭',
    all: '全部',
    preview: '预览',
    authView: '权限查看',
    batchDelete: '批量删除',
    newSuccess: '新增成功',
    editSuccess: '修改成功',
    deleteSuccess: '删除成功',
    opeartionSuccess: '操作成功',
    export: '导出',
    import: '导入',
    opeartion: '操作'
  }
}
export default lang
